const DEFAULT_ZOOM = 1

function finite(value, fallback = 0) {
  const number = Number(value)
  return Number.isFinite(number) ? number : fallback
}

export function normalizeViewportSize(value) {
  return {
    width: Math.max(0, finite(value?.width)),
    height: Math.max(0, finite(value?.height)),
  }
}

export function cameraFromViewport(view, viewportSize) {
  const { width, height } = normalizeViewportSize(viewportSize)
  const zoom = Math.min(64, Math.max(0.01, finite(view?.zoom, DEFAULT_ZOOM) || DEFAULT_ZOOM))
  const panX = finite(view?.panX)
  const panY = finite(view?.panY)
  return {
    centerX: (width / 2 - panX) / zoom,
    centerY: (height / 2 - panY) / zoom,
    zoom,
  }
}

export function viewportFromCamera(camera, viewportSize) {
  const { width, height } = normalizeViewportSize(viewportSize)
  const zoom = Math.min(64, Math.max(0.01, finite(camera?.zoom, DEFAULT_ZOOM) || DEFAULT_ZOOM))
  const centerX = finite(camera?.centerX)
  const centerY = finite(camera?.centerY)
  return {
    panX: width / 2 - centerX * zoom,
    panY: height / 2 - centerY * zoom,
    zoom,
  }
}

export function localViewState(canvasId, view, viewportSize, previous = null) {
  const size = normalizeViewportSize(viewportSize)
  if (!size.width && !size.height && previous) return { ...previous }
  const camera = cameraFromViewport(view, size)
  return {
    canvasId,
    panX: finite(view?.panX),
    panY: finite(view?.panY),
    zoom: camera.zoom,
    centerX: camera.centerX,
    centerY: camera.centerY,
    viewportWidth: size.width,
    viewportHeight: size.height,
    updatedAt: Date.now(),
  }
}

export function restoreLocalView(view, viewportSize) {
  if (!view) return { panX: 0, panY: 0, zoom: DEFAULT_ZOOM }
  if (Number.isFinite(Number(view.centerX)) && Number.isFinite(Number(view.centerY))) {
    return viewportFromCamera(view, viewportSize)
  }
  return {
    panX: finite(view.panX),
    panY: finite(view.panY),
    zoom: Math.min(64, Math.max(0.01, finite(view.zoom, DEFAULT_ZOOM) || DEFAULT_ZOOM)),
  }
}

export function sameCamera(left, right, epsilon = 1e-6) {
  if (!left || !right) return false
  return Math.abs(finite(left.centerX) - finite(right.centerX)) <= epsilon
    && Math.abs(finite(left.centerY) - finite(right.centerY)) <= epsilon
    && Math.abs(finite(left.zoom, DEFAULT_ZOOM) - finite(right.zoom, DEFAULT_ZOOM)) <= epsilon
}
